// ** Redux Imports
/* eslint-disable  */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { inventory } from "../../../../api/Api";

export const getAllInventoryFolder = createAsyncThunk(
  "appInventory/getAllFolder",
  async (query) => {
    try {
      return inventory.getAllFolder(query);
    } catch (error) {
      console.error(error);
    }
  }
);

export const getInventoryFolder = createAsyncThunk(
  "appInventory/getInventoryFolder",
  async (id) => {
    try {
      return inventory.getAllFolder(id);
    } catch (error) {
      console.error(error);
    }
  }
);

export const addInventoryFolder = createAsyncThunk(
  "appInventory/InventoryFolder",
  async (values) => {
    try {
      return inventory.createInventoryFolder(values);
    } catch (error) {
      console.error(error);
    }
  }
);

export const editInventoryFolder = createAsyncThunk(
  "editInventory/InventoryFolder",
  async (values) => {
    try {
      return inventory.editInventoryFolder(values.data, values.id);
    } catch (error) {
      console.error(error);
    }
  }
);

export const deleteInventoryFolder = createAsyncThunk(
  "appInventoryFolder/deleteInventoryFolder",
  async (id) => {
    return inventory.deleteInventoryFolder(id);
  }
);

export const getAllInventoryItem = createAsyncThunk(
  "appInventory/getAllItem",
  async (query) => {
    try {
      return inventory.getAllItem(query);
    } catch (error) {
      console.error(error);
    }
  }
);

export const getAllInventoryItemForSearch = createAsyncThunk(
  "appInventory/getAllInventoryItemForSearch",
  async (query) => {
    try {
      if (query.condition.q === "") {
        return [];
      }
      return inventory.getAllItem(query);
    } catch (error) {
      console.error(error);
    }
  }
);

export const getInventoryItem = createAsyncThunk(
  "appInventory/getInventoryItem",
  async (id) => {
    try {
      return inventory.getItem(id);
    } catch (error) {
      console.error(error);
    }
  }
);

export const addInventoryItem = createAsyncThunk(
  "appInventory/InventoryItem",
  async (values) => {
    try {
      return inventory.createInventoryItem(values);
    } catch (error) {
      console.error(error);
    }
  }
);

export const editInventoryItem = createAsyncThunk(
  "appInventory/editInventoryItem",
  async (data) => {
    try {
      return inventory.editInventoryItem(data.data, data.id);
    } catch (error) {
      console.error(error);
    }
  }
);

export const deleteInventoryItem = createAsyncThunk(
  "appInventoryItem/deleteInventoryItem",
  async (id) => {
    return inventory.deleteInventoryItem(id);
  }
);

export const appInventorySlice = createSlice({
  name: "appInventory",
  initialState: {
    inventoryFolder: [],
    inventoryItem: [],
    inventoryItemForSearch: [],
    selectedInventoryItem: {},
    inventoryFolderFetched: false,
    inventoryItemFetched: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllInventoryFolder.fulfilled, (state, action) => {
        state.inventoryFolder = action.payload?.data?.data;
        state.folderMetaData = action.payload?.data?.metaData;
        state.inventoryFolderFetched = true;
        state.inventoryItemFetched = false;
      })
      .addCase(getAllInventoryItem.fulfilled, (state, action) => {
        state.inventoryItem = action.payload?.data?.data;
        state.folderItemMetaData = action.payload?.data?.metaData;
        state.inventoryItemFetched = true;
        state.inventoryFolderFetched = false;
      })
      .addCase(getAllInventoryItemForSearch.fulfilled, (state, action) => {
        if (action.meta?.arg?.condition?.q === "") {
          state.inventoryItemForSearch = [];
          return;
        }
        state.inventoryItemForSearch = action.payload?.data?.data;
      })
      .addCase(getInventoryItem.fulfilled, (state, action) => {
        state.selectedInventoryItem = action?.payload?.data?.data;
      })

      .addCase(addInventoryFolder.fulfilled, (state, action) => {
        state.inventoryFolderFetched = false;
      })
      .addCase(editInventoryFolder.fulfilled, (state, action) => {
        state.inventoryFolderFetched = false;
      })
      .addCase(deleteInventoryFolder.fulfilled, (state, action) => {
        state.inventoryFolderFetched = false;
      });
  },
});

export default appInventorySlice.reducer;
